import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../style/Carousel.css";
import img1 from "../assets/images/declan-sun-KHroScK-IeY-unsplash.jpg";
import img2 from "../assets/images/ian-talmacs-SKR557m6CGM-unsplash.jpg";
import img3 from "../assets/images/ian-talmacs-WOw0ISrS9HI-unsplash.jpg";
import img4 from "../assets/images/kostiantyn-vierkieiev-dNdZySdDXoA-unsplash.jpg";
import img5 from "../assets/images/randy-laybourne-K3rhq5d9Jwo-unsplash.jpg";

const images = [
  {
    url: img1,
    header: "Driving Success with Swift Precision and Uncompromising Quality.",
    text: "Bridging the gap between Engineering Trades to bring forth visionary projects that shape the future with innovation and efficiency.",
  },
  {
    url: img2,
    header:
      "Enthralling Acumen, Astounding Celerity, and Matchless Craftsmanship.",
    text: "Fostering a dynamic partnership, resulting in groundbreaking projects that reflect a harmonious blend of creativity, vision, and practicality.",
  },
  {
    url: img3,
    header: "Empowering projects with precision and unwavering commitment..",
    text: "Elevating Steel Construction Narratives: Unleashing the Potential of Steel Detailing, Pioneering a Future Fueled by Uncompromising Quality and Collaborative Ingenuity.",
  },
  { url: img4, header: "Rapid execution and top-tier quality make a compelling combination.", text: "Navigating the complexities of projects with confidence, turning dreams into concrete reality through seamless coordination and a holistic approach." },
  { url: img5, header: "Swift success and superior excellence create an attractive alliance.", text: "Offerings that facilitate cooperation between clients and  designers in planning upcoming projects." },
];

const Carousel = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [index]);

  const nextSlide = () => {
    setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  return (
    <div className="carousel-container">
      <AnimatePresence>
        <motion.div
          key={index}
          className="carousel-slide"
          initial={{ opacity: 0, x: 100 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -100 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
        >
          <img
            src={images[index].url}
            className="carousel-image"
            alt="carousel"
          />
          <div className="carousel-overlay">
            <h1 className="carousel-header">{images[index].header}</h1>
            <p className="carousel-text">{images[index].text}</p>
          </div>
        </motion.div>
      </AnimatePresence>
      <button className="prev" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="next" onClick={nextSlide}>
        &#10095;
      </button>
    </div>
  );
};

export default Carousel;
